import { DonationListSort } from 'gql/types';
import { Sorter } from 'modules/common/components';
import { useSort } from 'modules/common/hooks';
import { options } from 'modules/donor/components/DonorDonationCardList/DonorDonationCardListSorter/options';
import { FC } from 'react';

const useDonationListSort = () => useSort<DonationListSort>();

type PropTypes = {
  sorting: ReturnType<typeof useDonationListSort>;
};

export const DonorDonationCardListSorter: FC<PropTypes> = ({ sorting }) => (
  <Sorter sorting={sorting as ReturnType<typeof useSort>} options={options} />
);
